import { axios } from '@/utils/request'
import Vue from 'vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'

// 获取分类
export function getStockSkuCategory() {
  return axios({
    url: '/api/stockSkuCategory?category_type=3',
    method: 'GET'
  })
}

// 获取选品列表
export function getProductList(params) {
  return axios({
    url: '/frontend/basicProduct',
    method: 'GET',
    params: params
  })
}

// 获取选品详情
export function getProductDetail(params, token) {
  let url = ''
  console.log(token)
  if (token) {
    url = '/distribution/basicProduct/'
  } else {
    url = '/frontend/basicProduct/'
  }
  return axios({
    url: url + params.id,
    method: 'GET',
    params: params
  })
}

// frontend/basicProduct/getPurchaseRule/1705
export function getPurchasePrice(params) {
  let url = '/distribution/basicProduct/getPurchaseRule/'
  if (!Vue.ls.get(ACCESS_TOKEN)) {
    url = '/frontend/basicProduct/getPurchaseRule/'
  }
  return axios({
    url: url + params.id,
    method: 'GET',
    params: params
  })
}

// /distribution/basicProduct/districtLogistics/397
export function getDistrictLogistics(params) {
  return axios({
    url: '/frontend/districtLogistics/' + params.id,
    method: 'GET',
    params: params
  })
}

export function exchangeRate() {
  return axios({
    url: '/api/exchangeRate',
    method: 'GET'
  })
}

export function getUSDRate(data) {
  return axios({
    url: 'api/exchangeRate/getOneToOneExchangeRateConversionRate',
    method: 'POST',
    data
  })
}

// 获取选品列表
export function getBasicProducts(params) {
  let url = '/distribution/basicProducts'
  if (!Vue.ls.get(ACCESS_TOKEN)) {
    url = '/frontend/basicProducts'
  }
  return axios({
    url: url,
    method: 'GET',
    params: params
  })
}
// 获取选品列表
export function getCateGoRys(params) {
  return axios({
    url: '/frontend/basicProductCategorys',
    method: 'GET',
    params: params
  })
}
// 获取选品pod设计模板
export function getPodTemplate(params) {
  return axios({
    url: '/distribution/podTemplate',
    method: 'GET',
    params
  })
}

// 用户商品分类列表
export function getProductCategory(params) {
  return axios({
    url: '/distribution/userBasicProductCategory',
    method: 'GET',
    params
  })
}

// 添加用户商品分类
export function addProductCategory(data) {
  return axios({
    url: '/distribution/userBasicProductCategory',
    method: 'POST',
    data
  })
}
// 更改用户商品分类
export function putProductCategory(data) {
  const { parent_id } = data
  delete data.parent_id
  return axios({
    url: '/distribution/userBasicProductCategory/' + parent_id,
    method: 'PUT',
    data
  })
}
// 删除用户商品分类
export function deleteProductCategory(id) {
  return axios({
    url: '/distribution/userBasicProductCategory/' + id,
    method: 'DELETE'
  })
}
// 更新分类排序
export function updateSort(data) {
  return axios({
    url: '/distribution/userBasicProductCategory/updateSort',
    method: 'POST',
    data
  })
}
// 批量更改分类
export function changeClass(data) {
  return axios({
    url: '/distribution/basicProduct/collectProducts',
    method: 'POST',
    data
  })
}
